import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const slice = createSlice({
  name: "@pm2/ui-store",
  initialState: {},
  reducers: {
    setPendingMegaMenu(state, action) {
      state.pendingMegaMenu = action.payload;
    },
    openMegaMenu(state, action) {
      state.megaMenu = [action.payload];
      state.pendingMegaMenu = void 0;
    },
    setMegaMenu(state, action) {
      state.megaMenu = action.payload;
      state.pendingMegaMenu = void 0;
    },
    pushMegaMenuLayer(state, action) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.push(action.payload);
    },
    replaceMegaMenuLayer(state, action) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.splice(-1, 1, action.payload);
    },
    popMegaMenu(state) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.pop();
    },
    closeMegaMenu(state) {
      state.megaMenu = void 0;
      state.pendingMegaMenu = void 0;
    },
    openLeftAside(state, action) {
      state.leftAside = action.payload;
    },
    closeLeftAside(state) {
      state.leftAside = void 0;
    },
    openRightAside(state, action) {
      state.rightAside = action.payload;
    },
    closeRightAside(state) {
      state.rightAside = void 0;
    },
    openIbookPreview(state, action) {
      state.ibookPreviewId = action.payload;
    },
    closeIbookPreview(state) {
      state.ibookPreviewId = void 0;
    },
    openLightbox(state, action) {
      state.lightboxContent = action.payload.content;
      state.lightboxSpeechFile = action.payload.speechFile;
    },
    closeLightbox(state) {
      state.lightboxContent = void 0;
      state.lightboxSpeechFile = void 0;
    },
    toggleResources(state, action) {
      state.showResources = action.payload ?? !state.showResources;
    }
  }
});
const pm2InterfaceStore = createIndependentStore(slice);

export { pm2InterfaceStore };
//# sourceMappingURL=store.interface.js.map
